import React from 'react';
import { styled } from '@linaria/react';

import { Spinner } from '../icon';

const SubmitSpin = styled.div`
  display: flex;
  justify-content: center;
  & svg {
    fill: var(--bb-field-placeholder);
  }
`;

const SubmitSpinner: React.FC = () => (
  <SubmitSpin>
    <Spinner
      width="19.5"
      height="19.5"
    />
  </SubmitSpin>
);

export default SubmitSpinner;
